export let DELETE_DIRECTION;

(function (DELETE_DIRECTION) {
  DELETE_DIRECTION["BACKWARD"] = "backward";
  DELETE_DIRECTION["FORWARD"] = "forward";
})(DELETE_DIRECTION || (DELETE_DIRECTION = {}));

export let LIST_TEXT_SCENARIOS;

(function (LIST_TEXT_SCENARIOS) {
  LIST_TEXT_SCENARIOS["JOIN_SIBLINGS"] = "joinSiblings";
  LIST_TEXT_SCENARIOS["JOIN_DESCENDANT_TO_PARENT"] = "joinDescendantToParent";
  LIST_TEXT_SCENARIOS["JOIN_TO_SIBLING_DESCENDANT"] = "joinToSiblingDescendant";
  LIST_TEXT_SCENARIOS["JOIN_PARAGRAPH_WITH_LIST"] = "joinParagraphWithList";
  LIST_TEXT_SCENARIOS["JOIN_PARENT_SIBLING_TO_PARENT_CHILD"] = "joinParentSiblingToParentChild";
  LIST_TEXT_SCENARIOS["JOIN_LIST_ITEM_WITH_PARAGRAPH"] = "joinListItemWithParagraph";
})(LIST_TEXT_SCENARIOS || (LIST_TEXT_SCENARIOS = {}));